Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIconOutlined = void 0;
var _styles = require("../../../../../styles");
var _reactNative = require("react-native-web");
var useIconOutlined = exports.useIconOutlined = function useIconOutlined() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    boxShadows = _STYLES$useStyles.boxShadows;
  var _border = 0.125;
  var _small = 2.5625;
  var _normal = 2.8125;
  var _large = 3.8125;
  var iconOutlined = {
    label: Object.assign({
      textDecorationLine: 'none',
      backgroundColor: colors.brandContrast,
      color: colors.brand,
      padding: 0,
      justifyContent: 'center',
      alignItems: 'center'
    }, _reactNative.Platform.select({
      web: {
        display: 'inline-flex',
        border: "".concat((0, _styles.getREM)(_border), " solid ").concat(colors.brand),
        cursor: 'pointer'
      },
      "default": {
        borderColor: colors.brand,
        borderWidth: (0, _styles.getREM)(_border),
        borderStyle: 'solid'
      }
    }), boxShadows.button.web, boxShadows.button.android),
    pointerOver: Object.assign({}, boxShadows.button_pointerOver.web),
    small: {
      width: (0, _styles.getREM)(_small),
      height: (0, _styles.getREM)(_small),
      borderRadius: (0, _styles.getREM)(_small / 2)
    },
    normal: {
      width: (0, _styles.getREM)(_normal),
      height: (0, _styles.getREM)(_normal),
      borderRadius: (0, _styles.getREM)(_normal / 2)
    },
    large: {
      width: (0, _styles.getREM)(_large),
      height: (0, _styles.getREM)(_large),
      borderRadius: (0, _styles.getREM)(_large / 2)
    }
  };
  return {
    iconOutlined: iconOutlined,
    sizes: {
      border: _border,
      small: _small,
      normal: _normal,
      large: _large
    }
  };
};